import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'phone',
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  transform(value: string): string {
    return `${value.substring(0, 4)} ${value.substring(4, 6)} ${value.substring(6, 9)} ${value.substring(9, 12)}`
  }
}
